/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class TithelyAppsService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Get the data source backing the organization's groups
     * Defers to the Apps backend, which owns the (read-only) groups data source decision, and collapses its per-location answer to the single `people` or `breeze` value the UI needs.
     * @returns any OK
     * @throws ApiError
     */
    public getAppsGroupsDataSource(): CancelablePromise<{
        data: {
            /**
             * Org-wide count of open, non-archived People groups. Null when every location is backed by Breeze (the Apps backend omits it).
             */
            people_groups_count: number | null;
            data_source: 'people' | 'breeze';
        };
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/tithely/apps/groups-data-source',
            errors: {
                400: `Bad request`,
                401: `User is unauthorized.`,
                403: `Access Denied`,
                404: `Not Found`,
            },
        });
    }

    /**
     * Get App's Profile Data Source
     * @returns any OK
     * @throws ApiError
     */
    public getAppsProfileDataSource(): CancelablePromise<{
        data: 'people' | 'breeze';
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/tithely/apps/profile-data-source',
            errors: {
                401: `User is unauthorized.`,
                403: `Access Denied`,
            },
        });
    }

    /**
     * Set App's Profile Data Source
     * @returns void
     * @throws ApiError
     */
    public setAppsProfileDataSource({
        requestBody,
    }: {
        requestBody?: {
            profile_data_source: 'people' | 'breeze';
        },
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/tithely/apps/profile-data-source',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `User is unauthorized.`,
                403: `Access Denied`,
            },
        });
    }

}
